<template>
  <div style="background-color:  #f0f2f5">
    <Filter />
    <Table />
    <Drawer />
  </div>
</template>
<script>
import { defineComponent, reactive, toRefs, provide, onMounted } from 'vue'
import Filter from './components/filter.vue'
import Table from './components/table.vue'
import Drawer from './components/drawer'
import { common_querySiteInfo_get } from './../../server/modules/3426'
import {
  post_abDevice_page,
  post_abDevice_save,
  get_abDevice_remove
} from './../../server/modules/21937'
import { message } from 'ant-design-vue'
export default defineComponent({
  name: '调试设备',
  components: {
    Filter,
    Table,
    Drawer
  },
  setup() {
    const state = reactive({
      drawerTitle: '创建调试设备',
      flowRatePercent: 0,
      flowRateDataSource: [],
      flowRateVisible: false,
      changeWeight: () => {
        state.flowRatePercent = 0
        state.flowRateDataSource.forEach(i => {
          state.flowRatePercent += i.weight
        })
        if (state.flowRatePercent > 100) {
          message.error('流量占用总和不能大于100%')
        }
      },
      allocationFlow: record => {
        state.flowRatePercent = 0
        state.flowRateVisible = true
        if (!record.abLayerAllocationDTOS) {
          record.abLayerAllocationDTOS = []
        }
        state.flowRateDataSource = JSON.parse(
          JSON.stringify(record.abLayerAllocationDTOS)
        )
        state.flowRateDataSource.forEach(i => {
          state.flowRatePercent += i.weight
        })
      },
      closeflowRateDrawer: () => {
        state.flowRateVisible = false
      },
      createFormRef: null,
      createVisible: false,
      closeCreateDrawer: () => {
        state.createFormRef.resetFields()
        state.createVisible = false
      },
      saveCreateDrawer: () => {
        state.createFormRef.validate().then(async () => {
          const { success, retInfo } = await post_abDevice_save({
            ...state.elementParams,
            ...state.createForm
          })
          if (success) {
            state.createVisible = false
            state.pageInfo.pageNum = 1
            state.getTableList()
          } else {
            message.error(retInfo)
          }
        })
      },
      createForm: {
        name: '',
        distinctId: null
      },
      resetFormData: () => {
        state.elementParams = {
          name: null,
          creater: null,
          distinctId: null
        }
        state.pageInfo = {
          pageSize: 10,
          pageNum: 1,
          total: 0,
          pages: 1
        }
        state.getTableList()
      },
      createFormRules: {
        name: [
          { required: true, message: '请输入设备名称', trigger: 'blur' },
          {
            validator: (rule, value) => {
              const regex = /^[\u4e00-\u9fa5a-zA-Z0-9_\-'"‘’“”]+$/
              if (!regex.test(value)) {
                return Promise.reject(
                  new Error(
                    '支持输入中文、英文、数字、下划线、中划线、引号、双引号，不支持特殊字符'
                  )
                )
              } else {
                return Promise.resolve()
              }
            },
            trigger: 'blur'
          }
        ],
        distinctId: [
          {
            required: true,
            message: '请输入Distinct_Id',
            trigger: 'blur'
          }
        ]
      },
      createFormDisabled: false,
      deleteLayer: async record => {
        const { success, retInfo } = await get_abDevice_remove({
          deviceId: record.id
        })
        if (success) {
          state.pageInfo.pageNum = 1
          state.getTableList()
        } else {
          message.error(retInfo)
        }
      },
      editLayer: record => {
        state.drawerTitle = '编辑调试设备'
        state.createFormDisabled = true
        state.createForm = JSON.parse(JSON.stringify(record))
        state.createVisible = true
      },
      createNewLayer: () => {
        state.drawerTitle = '创建调试设备'
        state.createForm = {
          name: '',
          distinctId: ''
        }
        state.createFormDisabled = false
        state.createVisible = true
      },
      elementParams: {
        name: null,
        creater: null,
        distinctId: null
      },
      pageInfo: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
        pages: 1
      },
      brands: [],
      channels: [],
      sites: [],
      dataSource: [],
      getElementsInfo: async () => {
        const { data } = await common_querySiteInfo_get()
        state.brands = data[1]
        state.channels = data[2]
        state.sites = data[3]
      },
      onPageChange: (page, pageSize) => {
        if (pageSize !== state.pageInfo.pageSize) {
          state.pageInfo.pageNum = 1
        } else {
          state.pageInfo.pageNum = page
        }
        state.pageInfo.pageSize = pageSize
        state.getTableList()
      },
      getTableList: async isRest => {
        isRest && (state.pageInfo.pageNum = 1)
        const { success, data } = await post_abDevice_page({
          ...state.elementParams,
          ...state.pageInfo
        })
        if (success) {
          state.dataSource = data.list
          state.pageInfo.total = data.total
          state.pageInfo.pages = data.pages
        }
      }
    })

    provide('initState', state)
    onMounted(() => {
      state.getElementsInfo()
      state.getTableList()
    })
    return {
      ...toRefs(state)
    }
  }
})
</script>
